import { useGameplay } from '@sorrem-client/ui/features/PlayPage/gameplay-context';
import { useDisplaySettings, usePrefersReducedMotion } from '@sorrem-client/ui/hooks';
import { useEffect } from 'react';

/**
 * Hands the account's display settings to the game, which draws damage
 * numbers and essence bars by them (#200, #202), and the player's
 * reduced-motion preference, which its countdown follows (#266).
 */
export function useSyncDisplaySettings(): void {
    const { bridge } = useGameplay();
    const { displaySettings } = useDisplaySettings();
    const reducedMotion = usePrefersReducedMotion();
    useEffect(() => {
        bridge.setDisplaySettings(displaySettings);
    }, [bridge, displaySettings]);
    useEffect(() => {
        bridge.setReducedMotion(reducedMotion);
    }, [bridge, reducedMotion]);
}
